import React, { useEffect, useState } from "react";
import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import { finishWechatLogin, saveCnRelay } from "./cn-auth-service";
import { clearCnLoginIntent, readCnLoginIntent } from "./cn-login-intent";
import { UserAuthCard, UserAuthShell } from "../auth/user-auth-layout";

export default function CnWechatCallback() {
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const intent = readCnLoginIntent();
    if (!code || !state || !intent || state !== intent.wechatState) {
      clearCnLoginIntent();
      setError("微信登录请求无效或已过期");
      return;
    }
    window.history.replaceState(null, "", "/cn/wechat/callback");

    finishWechatLogin(code, state)
      .then((tokens) => saveCnRelay({ ...intent, tokens }))
      .then((delivery) => {
        clearCnLoginIntent();
        if (intent.flow === "callback") {
          if (!delivery.redirectUri) throw new Error("Missing callback URI");
          window.location.replace(delivery.redirectUri);
        } else {
          window.location.replace("/auth-granted");
        }
      })
      .catch(() => setError("微信登录失败，请重新发起登录"));
  }, []);

  return (
    <UserAuthShell maxWidth={420}>
      <UserAuthCard contentSx={{ p: 4 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          {error ? (
            <Alert severity="error">{error}</Alert>
          ) : (
            <Box
              sx={{
                width: 62,
                height: 62,
                display: "grid",
                placeItems: "center",
                borderRadius: "50%",
                bgcolor: "#edf6f8",
              }}
            >
              <CircularProgress size={30} />
            </Box>
          )}
          <Typography sx={{ color: "#425a64", fontWeight: 600 }}>
            {error || "正在完成微信登录…"}
          </Typography>
        </Stack>
      </UserAuthCard>
    </UserAuthShell>
  );
}
